import { render } from "./edit-contact-list-modal.vue?vue&type=template&id=d8b22904"
import script from "./edit-contact-list-modal.vue?vue&type=script&lang=js"
export * from "./edit-contact-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__